// Client-side display-only preview of the next version - the same
// default-increment math PRD 24 applies server-side (patch bump only). The
// actual persisted version is always computed server-side at publish time,
// so this is never treated as authoritative (Frontend PRD 08's own "Core
// logic" section).
export function bumpPatch(version: string): string {
  const match = version.match(/^v(\d+)\.(\d+)\.(\d+)$/)
  if (!match) return version
  const [, major, minor, patch] = match
  return `v${major}.${minor}.${Number(patch) + 1}`
}
